import { Component, OnInit } from '@angular/core';
import { FilterSearchingBaseViewModel, Tc } from 'src/app/components/core/_infrastructure/types/common';
import { AlertaProductoRechazadoExService } from '../alertaProductoRechazadoEx.service';
import { FilterSearchingAlertaProductoRechazadoExViewModel, AlertaProductoRechazadoExItemResultsViewModel } from '../alertaProductoRechazadoEx.types';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { GlobalService } from '../../../../core/_infrastructure/classes/services/global.service';

@Component({
    selector: 'app-alertaproductorechazadoex-wrapper',
    templateUrl: './alertaproductorechazadoex-wrapper.component.html',
})
export class AlertaProductoRechazadoExWrapperComponent extends ComponentBase implements OnInit {
    visibilitySpinner = false;
    searching = false;
    result: AlertaProductoRechazadoExItemResultsViewModel | null;
    payload?: FilterSearchingAlertaProductoRechazadoExViewModel;
    edition = false;

    listPais: Tc[];
    listGrupo: Tc[];
    listForma: Tc[];

    constructor(
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private alertaProductoRechazadoExService: AlertaProductoRechazadoExService,
        private globalService: GlobalService,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit(): void {
        this.recoverLastSearch();

        this.globalService.getAllPaises().subscribe(params => {
            this.listPais = params;
        });

        this.globalService.getGrupos().subscribe(params => {
            this.listGrupo = params;
        });
    }

    onSearch(payload: FilterSearchingAlertaProductoRechazadoExViewModel): void {
        if (!payload) {
            return;
        }

        this.payload = { ...payload } as FilterSearchingAlertaProductoRechazadoExViewModel; // To keep a copy to be used in the lazy search (paginator)

        this.alertaProductoRechazadoExService.getAlertasProductosRechazadosEx(this.payload).subscribe(results => {
            this.result = results;
            this.searching = true;
        });
    }

    onSearchLazy(lazyLoadParams: FilterSearchingBaseViewModel): void {
        const payload = {
            ...this.payload,
            PageNumber: lazyLoadParams.PageNumber,
            Asc: lazyLoadParams.Asc,
            OrderBy: lazyLoadParams.OrderBy,
        } as FilterSearchingAlertaProductoRechazadoExViewModel;
        this.onSearch(payload);
    }

    onReset($event: any): void {
        this.searching = false;
        this.payload = new FilterSearchingAlertaProductoRechazadoExViewModel();
        this.alertaProductoRechazadoExService.clearLastSearch();
        this.result = null;
        this.listForma = [];
    }

    private recoverLastSearch() {
        this.payload = this.alertaProductoRechazadoExService.getLastSearch();
    }

    onExportExcel(): void {
        this.visibilitySpinner = true;

        let model: FilterSearchingAlertaProductoRechazadoExViewModel = new FilterSearchingAlertaProductoRechazadoExViewModel();
        Object.assign(model, this.payload);

        this.alertaProductoRechazadoExService.export(model).subscribe(res => {
            this.OpenDownloadedFile(res);
            this.visibilitySpinner = false;
        });
    }

    exportIsAvailable(): boolean {
        return this.result?.ResultList ? this.result?.ResultList?.length > 0 : false;
    }

    onGroupSelected(grupoId: number): void {
        if (!grupoId) {
            this.listForma = [];
            return;
        }
        this.globalService.getFormasByGrupo(grupoId).subscribe((params: Tc[]) => {
            this.listForma = params;
        });
    }
}
